export default __webpack_public_path__ + "static/media/Gloves of the Ragereaver.dfbe9c50.jpg";